/* global lrg_login */

class LoginSocialBase {
  constructor(service, $form, $modalBody) {
    this.service = service;
    this.$form = $form;
    this.$modalBody = $modalBody;
    this.$button = $(`.js-loginModal__btn--${this.service}`, this.$form);

    this.api = null;
    this.ajax_url = lrg_login.ajaxurl
    this.nonce_ajax = lrg_login.ajaxnonce

    this.loginWithSocial = this.loginWithSocial.bind(this);
    this.stopLoading = this.stopLoading.bind(this);
    this.linkAccount = this.linkAccount.bind(this);
  }

  enableButton() {
    this.$button.prop('disabled', false);
  }

  startLoading() {
      this.$modalBody.addClass('is-loading');
      if(!$('.js-loginModal__spinner', this.$modalBody).length) {
        this.$modalBody.append(
          '<div class="c-loginModal__spinner js-loginModal__spinner l-spinner"><div class="l-spinner__el"></div></div>'
        )
      }
    }

  stopLoading() {
      this.$modalBody.removeClass('is-loading');
      $('.js-loginModal__spinner', this.$modalBody).remove();
  }

  handleErrors(errors) {
    const $errors = $('.js-loginModal__errorPlaceholder', this.$modalBody);
    if (errors && errors.length && errors[0]) {
      $errors.text(errors[0]);
    } else {
      $errors.text('');
    }
  }

  maybeReload(value) {
    if(value === 1 || value === '1' || value === true) {
      const redirect_url = this.$form.attr('data-redirect')
      if ( redirect_url ) {
        window.location.href = redirect_url
      } else {
        window.location.href = '/account/summary'
      }
    }
  }

  async linkAccount(userID) {
    const {nonce_ajax, ajax_url, service} = this;

    const $emailInput = $('.js-loginModal__input--email')
    const $passwordInput = $('.js-loginModal__input--password')
    this.startLoading();

    const {value = 0, errors = []} = await $.post({
      url: ajax_url,
      dataType: 'json',
      data: {
        action: 'lrg_member_link_login',
        service,
        nonce_ajax,
        userID,
        email: $emailInput.val(),
        password: $passwordInput.val(),
      },
      always: this.stopLoading,
    });

    this.stopLoading();
    this.handleErrors(errors);
    this.maybeReload(value)

  }

  async requestUserLinkAccount(userID) {
    const {$form} = this;
    $('[type="submit"]', $form).text('Link Account');
    $('button:not([type="submit"])', $form).hide();

      $form.off('submit')
        .on('submit', async (e) => {
          e.preventDefault();
          return this.linkAccount(userID)
        });
    }


  async testUserID(userID) {
    const { ajax_url, nonce_ajax, service } = this;

    this.startLoading();

    const {value = false, message = '', errors = []} = await $.post({
      url: ajax_url,
      dataType: 'json',
      data: {
        action: 'lrg_member_login_social',
        service,
        nonce_ajax,
        userID,
      },
    }).always(this.stopLoading);

    this.stopLoading();
    this.handleErrors(errors);
    this.maybeReload(value)

    switch (message) {
      case 'account_not_linked':
        return this.requestUserLinkAccount(userID);
      default:
        break;
    }
  }

  async loginWithSocial() {
    const userID = await this.getUserId()
    await this.testUserID(userID);
  }
}

export default LoginSocialBase;
